module.exports = __webpack_public_path__ + "9eacb01bcd00489965d01aa2e67d0374.svg";